'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import appConstants from 'constants/appConstants';

import teamActions from 'actions/TeamActionCreators';
import teamStore from 'stores/TeamStore';
import PageSection from 'components/base/PageSection';
import List from 'components/base/list-components/List';
import ListSection from 'components/base/list-components/ListSection';
import ListItem from 'components/base/list-components/ListItem';
import Avatar from 'components/base/Avatar';

import _ from 'underscore';
import utils from 'services/utils';
import personUtils from 'services/people/personUtils';
import moment from 'moment';

const propTypes = {
    error: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
};

class MembersOnLeaveWidget extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentDate: moment(),
        };
    }
    
    componentDidMount() {
        var _this = this;
        setTimeout(function () {
            teamActions.getUsersMembersOnLeave(_this.state.currentDate.format(appConstants.dates.formats.SERVER_POST_FORMAT));
        }, 0);
    }
    
    render() {

        var initialLoading = false;
        var membersOnLeaveContent = [];
        var error = null;
        var heading = "Members on Leave Today";
        var _this = this;
        let link = "";
        const linkString = '/teams/my-teams/?c=' + appConstants.ENUMS.TEAM_VIEW_OPTIONS.LEAVE;

        if (this.props.teams && this.props.teams.usersMembersOnLeave && this.props.teams.usersMembersOnLeave.items && this.props.teams.usersMembersOnLeave.items.Items.length > 0) {
            link = linkString;
            membersOnLeaveContent = this.props.teams.usersMembersOnLeave.items.Items.map(function (member, index) {

                var startDate = moment.utc(member.LeaveApplication[0].StartDate);
                var endDate = moment.utc(member.LeaveApplication[0].EndDate);
                var memberWillBeBack = "Last leave day " + utils.formatDate(endDate, false, appConstants.dates.formats.FULL_WITH_WEEKDAY);

                return (
                    <ListItem 
                        key={index} 
                        avatar={<Avatar profile={member} />} 
                        heading={personUtils.getFullName(member)} 
                        subheading={memberWillBeBack} 
                        link={"/members/" + member.Id + "/leave/"}
                    />
                );
                
            });
        } else if (this.props.teams && this.props.teams.usersMembersOnLeave && this.props.teams.usersMembersOnLeave.items && this.props.teams.usersMembersOnLeave.items.Items.length === 0) {
            link = linkString;
            membersOnLeaveContent.push(
                <ListItem key="0" content="No one is on leave today" />
            );
        } else if (this.props.teams && this.props.teams.usersMembersOnLeave && this.props.teams.usersMembersOnLeave.error) {
            error = heading; 
        } else {
            initialLoading = true;
        }

        return (
            <PageSection id="members-on-leave-widget">

                <List
                    icon="icon-members-on-leave"
                    id={this.props.id}
                    heading={heading}
                    link={link}
                    loading={initialLoading}
                    error={error}
                >
                    <ListSection maxItems={5}>
                        {membersOnLeaveContent}   
                    </ListSection>
                </List>     
            </PageSection>
        );
    }
}

MembersOnLeaveWidget.propTypes = propTypes;

export default MembersOnLeaveWidget; 
